import { Route, Routes } from "react-router-dom";
import { PlayHtmlPagePresenter } from "htmlpage/play/views/PlayHtmlPagePresenter";
import { HtmlPageThemeWrapper } from "htmlpage/layouts/HtmlPageThemeWrapper";

//HTMLThemeWrapper

export function HtmlPageRoutes() {
  return (
    <Routes>
      <Route path="" element={<HtmlPageThemeWrapper />}>
        <Route path="" element={<PlayHtmlPagePresenter />} />
      </Route>
      <Route path=":htmlPageId" element={<HtmlPageThemeWrapper />}>
        <Route path="" element={<PlayHtmlPagePresenter />}></Route>
      </Route>
    </Routes>
  );
}
